export default __webpack_public_path__ + "static/media/Blade's Cord of Waning Dusk.f5b43a74.jpg";